import React, { useEffect, useRef } from 'react';

const RadioWaveAnimation = ({ isActive = false }) => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef?.current;
    if (!canvas) return;

    const ctx = canvas?.getContext('2d');
    const width = canvas?.width;
    const height = canvas?.height;

    let phase = 0;
    const waves = [
      { amplitude: 20, frequency: 0.02, speed: 0.03, offset: 0 },
      { amplitude: 15, frequency: 0.03, speed: 0.02, offset: Math.PI / 2 },
      { amplitude: 25, frequency: 0.015, speed: 0.025, offset: Math.PI }
    ];

    const animate = () => {
      ctx?.clearRect(0, 0, width, height);

      waves?.forEach((wave, index) => {
        ctx?.beginPath();
        ctx.strokeStyle = `rgba(139, 115, 85, ${0.2 - index * 0.05})`;
        ctx.lineWidth = 2;

        for (let x = 0; x < width; x++) {
          const y = height / 2 + 
            Math.sin(x * wave?.frequency + phase + wave?.offset) * 
            wave?.amplitude * (isActive ? 1 : 0.3);
          
          if (x === 0) {
            ctx?.moveTo(x, y);
          } else {
            ctx?.lineTo(x, y);
          }
        }

        ctx?.stroke();
      });

      phase += isActive ? 0.05 : 0.02;
      animationRef.current = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      if (animationRef?.current) {
        cancelAnimationFrame(animationRef?.current);
      }
    };
  }, [isActive]);

  return (
    <canvas
      ref={canvasRef}
      width={400}
      height={120}
      className="radio-wave-canvas w-full h-full opacity-60"
      aria-hidden="true"
    />
  );
};

export default RadioWaveAnimation;